import { render, staticRenderFns } from "./ClientAppForm.vue?vue&type=template&id=2b5d40d4&"
import script from "./ClientAppForm.vue?vue&type=script&lang=ts&"
export * from "./ClientAppForm.vue?vue&type=script&lang=ts&"
import style0 from "./ClientAppForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports